<template>
  <b-modal
    size="lg"
    ref="email"
    hide-footer
    :title="`Traza de correo`"
  >
    <b-overlay :show="loading" v-if="version === '1'">
      <app-timeline>
        <app-timeline-item
          v-for="binnacle in items"
          :key="binnacle.fecha"
          icon="InfoIcon"
          :variant="'green'"
        >
          <div
            class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
          >
            <h6>{{ binnacle.tipo }}</h6>
            <small class="text-muted">
              {{ binnacle.fecha | dateCompleteFormat }}
            </small>
          </div>
          <div
            class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
          >
            <p>{{ binnacle.mensaje }}</p>
          </div>
        </app-timeline-item>
      </app-timeline>
    </b-overlay>
    <b-overlay :show="loadingEventos " v-if="version === '2'">
      <div
        v-for="evento in eventos"
        class="row border-top"
        :key="evento.timestamp"
        style="padding: 10px"
      >
        <div class="col-2">
          {{ evento.type }}
        </div>
        <div class="col-4">
          {{ evento.timestamp |dateFormatDateTime }}
        </div>
        <div class="col-3" v-if="evento.event && evento.event.ipAddress">
          <vs-chip>
            <vs-avatar
              icon="place"
              color="green"
            />
            {{ evento.event.ipAddress }}
          </vs-chip>
        </div>
        <div class="col-3" v-if="evento.event && evento.event.delayType">
          <vs-chip>
            <vs-avatar
              icon="schedule"
              color="red"
            />
            {{ evento.event.delayType }}
          </vs-chip>
        </div>
        <div class="col-3" v-if="evento.event && evento.event.expirationTime">
          <vs-chip>
            <vs-avatar
              icon="schedule"
              color="red"
            />
            {{ evento.event.expirationTime |dateFormatDateTime }}
          </vs-chip>
        </div>
        <div v-if="evento.event && evento.event.delayedRecipients">
          <div
            class="col-4"
            v-for="destinatario in evento.event.delayedRecipients"
            :key="destinatario.emailAddress"
          >
            <vs-chip>
              <vs-avatar
                icon="email"
              />
              {{ destinatario.emailAddress }}
            </vs-chip>
            {{ destinatario.diagnosticCode }}
          </div>
        </div>
        <div class="col-12" v-if="evento.event && evento.event.userAgent">
          <p class="text-archive">
            {{ evento.event.userAgent }}
          </p>
        </div>
        <div class="col-12" v-if="evento.event && evento.event.recipients">
          <vs-chip
            v-for="destinatario in evento.event.recipients"
            :key="destinatario"
          >
            <vs-avatar
              icon="email"
            />
            {{ destinatario }}
          </vs-chip>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { ioGetEmailTrace } from '@/febos/servicios/api/emails.api';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem';
import AppTimeline from '@core/components/app-timeline/AppTimeline';

export default {
  name: 'ModalTrace',
  components: { AppTimeline, AppTimelineItem },
  data() {
    return {
      loading: false,
      email: undefined,
      version: '1',
      items: []
    };
  },
  computed: {
    ...mapGetters('Emails', [
      'loadingEventos',
      'eventos',
      'email'
    ]),
  },
  methods: {
    ...mapActions('Emails', [
      'setActualEmail',
      'getEmailsEvents',
      'clearEvents'
    ]),
    async load(emailId) {
      this.items = [];
      this.email = undefined;
      this.loading = true;
      this.version = '1';
      try {
        const response = await ioGetEmailTrace({ mailid: emailId });
        const { email, registros, version } = response.data;
        this.items = registros;
        this.version = version;
        this.email = email;
      } finally {
        this.loading = false;
      }
      if (this.version === '2') {
        this.getEmailsEvents({ id: this.email.messageId, emailId });
      }
    },
    open(emailId) {
      this.$refs.email.show();
      this.load(emailId);
    }
  }
};
</script>
